import React from "react";
import PropTypes from "prop-types";
import Title from "../components/Title";
import Loading from "../components/Loading";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { pageActions } from "react-adaptive-cms";
import { withRouter } from "react-router-dom";
import "./PageView.scss";

const getPath = location => {
  return location.pathname.length > 1 ? location.pathname.slice(1) : "index";
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(Object.assign({}, pageActions), dispatch);
};

const mapStateToProps = state => ({
  page: state.page.page,
  pageLoading: state.page.pageLoading
});

class PageView extends React.Component {
  constructor() {
    super();

    this.state = {
      currentPath: ""
    };
  }

  componentDidMount() {
    const { loadPage, location } = this.props;
    const path = getPath(location);
    this.setState({ currentPath: path });
    loadPage(path);
  }

  componentWillReceiveProps(nextProps) {
    const path = getPath(nextProps.location);
    if (path !== this.state.currentPath) {
      this.setState({ currentPath: path });
      nextProps.loadPage(path);
    }
  }

  render404() {
    return (
      <div>
        <h3>Siden ble ikke funnet</h3>
        <p>
          Vennligst kontroller adressen eller <a href="/">gå til hjemmesiden</a>
        </p>
      </div>
    );
  }

  render() {
    const { page, pageLoading } = this.props;
    return (
      <div className="page-view--container">
        <Title
          title={
            (page.is404 ? "Page not found" : page.title || "Loading") +
            " - Kystverket"
          }
        />
        <div
          className="page-view--content artwork--container"
          id="pageView-scrollPane"
        >
          {pageLoading ? (
            <Loading />
          ) : page.is404 ? (
            this.render404()
          ) : (
            <div
              className="content"
              dangerouslySetInnerHTML={{ __html: page.content }}
            />
          )}
        </div>
      </div>
    );
  }
}

PageView.propTypes = {
  location: PropTypes.object,
  loadPage: PropTypes.func.isRequired,
  pageLoading: PropTypes.bool.isRequired,
  page: PropTypes.object.isRequired
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(PageView));
